import { Component } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { MCustomerMenuProductListResponse, MCustomerMenuSubcategoryResponse } from 'src/app/pages/homepage/homepage.module';
import { SharedPrefrences } from 'src/app/utils/utils.service';
import { WsSubHeaderService } from 'src/app/ws/wsSubHeader/ws-sub-header.service';
import { NavigationExtras, Router } from '@angular/router';


@Component({
  selector: 'app-sub-header-category',
  templateUrl: './sub-header-category.component.html',
  styleUrls: ['./sub-header-category.component.scss']
})
export class SubHeaderCategoryComponent {

  showNavBar = false
  customerMenuLists: any
  selectedCategoryName = ""
  selectedSubcategories?: any
  selectedProducts?: any
  selectedSubCategory: any;

  constructor(private router: Router,private wssubheaderservice: WsSubHeaderService) { }

  ngOnInit() {
    this.getCustomerMenuList();
  }

  hideShowMenu(isShow: boolean, categoryName: string,subCategories: MCustomerMenuSubcategoryResponse) {
    this.showNavBar = isShow
    this.selectedSubcategories = subCategories;
    this.selectedProducts = this.selectedSubcategories[0].productList;
    this.selectedSubCategory = this.selectedSubcategories[0].id;
    this.selectedCategoryName = categoryName;
  }
  subCategoryClick(productList: MCustomerMenuProductListResponse, selectedSubcategory: any) {
    this.selectedSubCategory = selectedSubcategory;
    this.selectedProducts = productList;
  }
  productClick(product: MCustomerMenuProductListResponse) {

  }

  /**
  * Date:- 09-06-2023
  * Method :- This method is used to get Customer menu List  With Details
  */
  async getCustomerMenuList() {
    const customerMenuListData = this.wssubheaderservice.getCustomerMenuList();
    await lastValueFrom(customerMenuListData).then(response => {
      if (response && response.statusCode == 200) {
        this.customerMenuLists = response.data.categoryList;
        SharedPrefrences.setCategoryId(this.customerMenuLists[0].id)
        SharedPrefrences.setCustomerMenuList(JSON.stringify(response.data))
      }
    })
  }

  goToShopAll(val: any, catId: any, subId?: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/shop-all/" + val], { 
      queryParams: { 
        c: catId
      }
  })
  }
}